<template>
  <navbar :onLanding="onLanding" :verifiedAccount="verifiedAccount">
    <template v-slot:nav-items>
      <li class="nav-item" v-if="show_account_select">
        <dropdown
          :isNavbarDropdown="true"
          :entries="accessible_accounts"
          :formatText="x => x['company_name']"
          :formatValue="x => x['account_id']"
          :selected="requested_account"
          @update:selected="onRequestedAccountChange"
        ></dropdown>
      </li>
      <li class="nav-item" v-if="!onLanding && verifiedAccount">
        <a class="nav-link" href="/home">
          <i class="fa fa-home" aria-hidden="true"></i>
          Dashboard
          <span class="sr-only">(current)</span>
        </a>
      </li>
      <li class="nav-item" v-if="isSuperAdmin">
        <a class="nav-link" href="/admin_static/home">
          <font-awesome-icon :icon="['fas', 'hammer']" />
          Admin
        </a>
      </li>
      <li class="nav-item" v-if="!onLanding && verifiedAccount">
        <a class="nav-link" href="/account">
          <i class="fa fa-user" aria-hidden="true"></i>
          {{ accountSettingLabel }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="logout" href="#">
          <i class="fa fa-sign-out-alt" aria-hidden="true"></i>
          Logout
        </a>
      </li>
      <li class="nav-item" v-if="!onLanding && verifiedAccount">
        <a class="nav-link btn btn-topbar ml-2" href="/create">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Create New Scan
        </a>
      </li>
      <li class="nav-item" v-if="isSubscribed">
        <a class="nav-link btn btn-topbar ml-2" href="/generate-risk-report">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Generate Risk Report
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHammer } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Dropdown from '~/components/dashboard/components/dropdown.vue';
import Navbar from '~/components/shared/templates/navbar.vue';

library.add(faHammer);

export default {
    name: 'navbar-main',
    components: { Navbar, Dropdown, FontAwesomeIcon },
    data() {
        return {
            show_account_select: false,
            accessible_accounts: [],
            requested_account_id: null,
            onLanding: false,
            isSubscribed: false,
            isSuperAdmin: false,
        };
    },
    props: {
        verifiedAccount: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        requested_account() {
            return this.accessible_accounts.find(
                (x) => x.account_id === this.requested_account_id,
            );
        },
        accountSettingLabel() {
            const width = window.innerWidth;
            return (width >= 996 && width <= 1024) ? ' Settings' : ' Account Settings';
        },
    },
    created() {
        try {
            this.loadSessionData();
        } catch (error) {
            localStorage.clear();
            sessionStorage.clear();
            this.loadSessionData();
        }
        const self = this;
        this.doBackendRequest(
            'GET',
            '/api/has_access_to_risk_report_feature',
            (response) => {
                if (response.status) {
                    self.isSubscribed = true;
                }
            },
            undefined,
            undefined,
        );
        this.doBackendRequest('GET', '/api/has_access_to_admin_feature', (response) => {
            if (response.is_super_admin) {
                self.isSuperAdmin = true;
            }
        }, undefined, undefined);
    },
    methods: {
        logout() {
            this.emptyLocalStorage();
            sessionStorage.clear();
            window.location.href = '/logout';
        },
        onRequestedAccountChange(selected) {
            sessionStorage.setItem('KEY_REQUESTED_ACCOUNT_ID', selected.account_id);
            localStorage.setItem('KEY_REQUESTED_ACCOUNT_ID', selected.account_id);
            // eslint-disable-next-line no-restricted-globals
            location.reload();
        },
        copyFromLocalToSession() {
            sessionStorage.setItem(
                'KEY_USER_ID',
                localStorage.getItem('KEY_USER_ID'),
            );
            sessionStorage.setItem(
                'KEY_REQUESTED_ACCOUNT_ID',
                localStorage.getItem('KEY_REQUESTED_ACCOUNT_ID'),
            );
            sessionStorage.setItem(
                'KEY_ACCESSIBLE_ACCOUNTS',
                localStorage.getItem('KEY_ACCESSIBLE_ACCOUNTS'),
            );
        },
        fillDataFromSession(self) {
            // eslint-disable-next-line no-param-reassign
            self.requested_account_id = sessionStorage.getItem(
                'KEY_REQUESTED_ACCOUNT_ID',
            );
            // eslint-disable-next-line no-param-reassign
            self.accessible_accounts = JSON.parse(
                sessionStorage.getItem('KEY_ACCESSIBLE_ACCOUNTS'),
            );
            // eslint-disable-next-line no-param-reassign
            if (self.accessible_accounts && self.accessible_accounts.length > 1) {
                // eslint-disable-next-line no-param-reassign
                self.show_account_select = true;
            }
        },
        loadSessionData() {
            let fromLocal = localStorage.getItem('KEY_USER_ID');
            if (fromLocal === 'undefined') {
                fromLocal = null;
            }
            let fromSession = sessionStorage.getItem('KEY_USER_ID');
            if (fromSession === 'undefined') {
                fromSession = null;
            }
            const self = this;
            // if fromLocal and not fromSession: copy fromLocal to session
            if (fromLocal && !fromSession) {
                self.copyFromLocalToSession();
                self.fillDataFromSession(self);
            } else if (!fromLocal && !fromSession) {
                this.doBackendRequest(
                    'GET',
                    '/api/session_data',
                    (response) => {
                        localStorage.setItem('KEY_USER_ID', response.user_id);
                        localStorage.setItem(
                            'KEY_REQUESTED_ACCOUNT_ID',
                            response.active_account_id,
                        );
                        localStorage.setItem(
                            'KEY_ACCESSIBLE_ACCOUNTS',
                            JSON.stringify(response.accessible_accounts),
                        );
                        self.copyFromLocalToSession();
                        self.fillDataFromSession(self);
                    },
                    undefined,
                    undefined,
                );
            } else {
                self.fillDataFromSession(self);
            }
        },
        updateModal(type, state) {
            this.modalState[type] = state;
            this.$emit('updateModal', {
                key: type,
                state,
            });
        },
    },
};
</script>

<style lang="scss">
    .navbar-nav {
        > li {
            hr {
              margin: .5rem auto;
              border-top: 3px solid #fff;
              width: 90%;
            }
            > a.nav-link, > a.nav-link-big {
                color: $white;
                background: $gray-primary;
                transition: all 0.15s ease-in-out;
                &:hover,
                &:focus {
                    color: $white !important;
                    text-decoration: none;
                    background: $gray-secondary !important;
                    border-radius: 2px;

                }
            }
            > a.btn-topbar {
                color: $black;
                background-color: $white;
                border-color: $white;
                max-width: 180px;
                &:hover {
                    color: $white !important;
                    background-color: $gray-secondary !important;
                    border-color: $gray-secondary !important;
                }
                &:disabled {
                    color: $gray-200;
                    background-color: $white;
                    border-color: $red;
                }
                i.fa-plus {
                    color: $red !important;
                }
            }
        }
    }
</style>
